import { render, staticRenderFns } from "./KusDocumentRemovePopup.vue?vue&type=template&id=0d5e5b02"
import script from "./KusDocumentRemovePopup.vue?vue&type=script&lang=js"
export * from "./KusDocumentRemovePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports